(function () {
  var DESKTOP_QUERY = '(min-width: 1200px)';
  var HOVER_QUERY = '(hover: hover) and (pointer: fine)';
  var desktopMedia = window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null;
  var hoverMedia = window.matchMedia ? window.matchMedia(HOVER_QUERY) : null;
  var hasPointerEvents = typeof window.PointerEvent !== 'undefined';

  function isDesktop() {
    return !desktopMedia || desktopMedia.matches;
  }

  function supportsHover() {
    return !!(hoverMedia && hoverMedia.matches);
  }

  function closestElement(target, selector) {
    if (!target) return null;

    if (target.nodeType !== 1) {
      target = target.parentElement;
    }

    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(selector);
  }

  function getHeaderBottom() {
    var header = document.querySelector('.wt-header') || document.querySelector('header');
    if (!header) return 0;
    return Math.round(header.getBoundingClientRect().bottom);
  }

  function setPanelTop(root) {
    root.style.setProperty('--dnm-panel-top', Math.max(0, getHeaderBottom()) + 'px');
  }

  function setOpen(root, open) {
    if (!isDesktop()) open = false;

    var panel = root.querySelector('[data-dnm-panel]');

    if (open) setPanelTop(root);

    root.classList.toggle('is-open', open);
    if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');

    root.querySelectorAll('[data-dnm-l1]').forEach(function (control) {
      var expanded = open && control.classList.contains('is-active');
      control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function clearL3(root) {
    root.classList.remove('dnm--has-l3');

    root.querySelectorAll('[data-dnm-l2]').forEach(function (control) {
      control.classList.remove('is-active');
      control.setAttribute('aria-expanded', 'false');
    });

    root.querySelectorAll('[data-dnm-l2-empty]').forEach(function (link) {
      link.classList.remove('is-active');
    });

    root.querySelectorAll('[data-dnm-l3-panel]').forEach(function (panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    });
  }

  function activateL2(root, key) {
    var hasL3 = false;

    root.querySelectorAll('[data-dnm-l2-empty]').forEach(function (link) {
      link.classList.remove('is-active');
    });

    root.querySelectorAll('[data-dnm-l2]').forEach(function (control) {
      var active = control.getAttribute('data-dnm-l2') === key;
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-expanded', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-dnm-l3-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-dnm-l3-panel') === key;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) hasL3 = true;
    });

    root.classList.toggle('dnm--has-l3', hasL3);

    var l3Column = root.querySelector('[data-dnm-column="l3"]');
    if (l3Column) l3Column.scrollTop = 0;
  }

  function activateEmptyL2(root, key) {
    root.querySelectorAll('[data-dnm-l2]').forEach(function (control) {
      control.classList.remove('is-active');
      control.setAttribute('aria-expanded', 'false');
    });

    root.querySelectorAll('[data-dnm-l2-empty]').forEach(function (link) {
      link.classList.toggle('is-active', link.getAttribute('data-dnm-l2-empty') === key);
    });

    root.querySelectorAll('[data-dnm-l3-panel]').forEach(function (panel) {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
    });

    root.classList.remove('dnm--has-l3');
  }

  function activateFirstL2(root, l1Index) {
    var firstL2WithChildren = root.querySelector('[data-dnm-l2^="' + l1Index + '-"]');
    var firstL2Empty = root.querySelector('[data-dnm-l2-empty^="' + l1Index + '-"]');

    if (firstL2WithChildren) {
      activateL2(root, firstL2WithChildren.getAttribute('data-dnm-l2'));
      return;
    }

    if (firstL2Empty) {
      activateEmptyL2(root, firstL2Empty.getAttribute('data-dnm-l2-empty'));
      return;
    }

    clearL3(root);
  }

  function activateL1(root, index) {
    root.querySelectorAll('[data-dnm-l1]').forEach(function (control) {
      var active = control.getAttribute('data-dnm-l1') === index;
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-expanded', root.classList.contains('is-open') && active ? 'true' : 'false');
    });

    var brandLayout = false;

    root.querySelectorAll('[data-dnm-l2-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-dnm-l2-panel') === index;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active && panel.getAttribute('data-dnm-brand-panel') === 'true') {
        brandLayout = true;
      }
    });

    root.classList.toggle('dnm--brand-layout', brandLayout);

    var l1Column = root.querySelector('[data-dnm-column="l1"]');
    var l2Column = root.querySelector('[data-dnm-column="l2"]');
    var l3Column = root.querySelector('[data-dnm-column="l3"]');

    if (l1Column) l1Column.scrollTop = 0;
    if (l2Column) l2Column.scrollTop = 0;
    if (l3Column) l3Column.scrollTop = 0;

    activateFirstL2(root, index);
  }

  function primeInitialState(root) {
    var activeL1 = root.querySelector('[data-dnm-l1].is-active') || root.querySelector('[data-dnm-l1]');
    if (!activeL1) return;
    activateL1(root, activeL1.getAttribute('data-dnm-l1'));
  }

  function initRoot(root) {
    if (!root) return;

    if (root.dataset.dnmInitialized === 'true') {
      primeInitialState(root);
      setPanelTop(root);

      if (root.dataset.dnmReady === 'true') {
        warmOpenIfHovered(root);
      }
      return;
    }

    root.dataset.dnmInitialized = 'true';
    root.dataset.dnmReady = 'false';

    var closeTimer = null;
    var hoverTimer = null;
    var cleanupFns = [];

    function addManagedListener(target, type, handler, options) {
      target.addEventListener(type, handler, options || false);
      cleanupFns.push(function () {
        target.removeEventListener(type, handler, options || false);
      });
    }

    function cleanupRoot() {
      cancelTimers();

      cleanupFns.forEach(function (cleanup) {
        cleanup();
      });
      cleanupFns = [];

      root.dataset.dnmInitialized = 'false';
      root.dataset.dnmReady = 'false';
      root._dnmRevealStarted = false;
      root._dnmCleanup = null;
    }

    root._dnmCleanup = cleanupRoot;

    function cancelTimers() {
      window.clearTimeout(closeTimer);
      window.clearTimeout(hoverTimer);
      closeTimer = null;
      hoverTimer = null;
    }

    function scheduleHover(callback, delay) {
      window.clearTimeout(hoverTimer);
      hoverTimer = window.setTimeout(function () {
        hoverTimer = null;
        callback();
      }, typeof delay === 'number' ? delay : 70);
    }

    function scheduleClose(delay) {
      if (closeTimer) return;

      closeTimer = window.setTimeout(function () {
        closeTimer = null;
        setOpen(root, false);
      }, typeof delay === 'number' ? delay : 120);
    }

    function closeForPlainTopLink() {
      cancelTimers();

      root.querySelectorAll('[data-dnm-l1]').forEach(function (control) {
        control.classList.remove('is-active');
        control.setAttribute('aria-expanded', 'false');
      });

      root.querySelectorAll('[data-dnm-l2-panel]').forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      });

      clearL3(root);
      root.classList.remove('dnm--brand-layout');
      setOpen(root, false);
    }

    function isPointInsideRect(x, y, rect) {
      return rect &&
        x >= rect.left &&
        x <= rect.right &&
        y >= rect.top &&
        y <= rect.bottom;
    }

    function isPointerInsideMenuBounds(event) {
      var nav = root.querySelector('.dnm__nav');
      var panel = root.querySelector('.dnm__panel-inner') || root.querySelector('[data-dnm-panel]');

      var x = event.clientX;
      var y = event.clientY;

      var navRect = nav ? nav.getBoundingClientRect() : null;
      var panelRect = panel ? panel.getBoundingClientRect() : null;

      return isPointInsideRect(x, y, navRect) || isPointInsideRect(x, y, panelRect);
    }

    function scheduleCloseIfOutsideBounds(event) {
      if (!root.classList.contains('is-open')) return;

      if (isPointerInsideMenuBounds(event)) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
        return;
      }

      scheduleClose(110);
    }

    function handleL1(control, delay) {
      if (!control || !root.contains(control)) return;
      var key = control.getAttribute('data-dnm-l1');
      cancelTimers();
      scheduleHover(function () {
        activateL1(root, key);
        setOpen(root, true);
      }, delay);
    }

    function handleL2(control, delay) {
      if (!control || !root.contains(control)) return;
      var key = control.getAttribute('data-dnm-l2');
      cancelTimers();
      scheduleHover(function () {
        activateL2(root, key);
      }, delay);
    }

    function handleEmptyL2(link, delay) {
      if (!link || !root.contains(link)) return;
      var key = link.getAttribute('data-dnm-l2-empty');
      cancelTimers();
      scheduleHover(function () {
        activateEmptyL2(root, key);
      }, delay);
    }

    function handleHoverTarget(target, delayOverride) {
      if (!target || !root.contains(target) || !isDesktop()) return null;

      var plainTop = closestElement(target, '[data-dnm-top-plain]');
      var l1 = closestElement(target, '[data-dnm-l1]');
      var l2 = closestElement(target, '[data-dnm-l2]');
      var l2Empty = closestElement(target, '[data-dnm-l2-empty]');

      if (plainTop && root.contains(plainTop)) {
        closeForPlainTopLink();
        return 'plain';
      }

      if (l1 && root.contains(l1)) {
        handleL1(l1, typeof delayOverride === 'number' ? delayOverride : (root.classList.contains('is-open') ? 50 : 0));
        return 'l1';
      }

      if (l2 && root.contains(l2)) {
        handleL2(l2, typeof delayOverride === 'number' ? delayOverride : 75);
        return 'l2';
      }

      if (l2Empty && root.contains(l2Empty)) {
        handleEmptyL2(l2Empty, typeof delayOverride === 'number' ? delayOverride : 75);
        return 'l2-empty';
      }

      return null;
    }

    function warmOpenIfHovered() {
      if (!isDesktop() || !supportsHover()) return;
      var hoveredControl = root.querySelector('[data-dnm-l1]:hover, [data-dnm-l2]:hover, [data-dnm-l2-empty]:hover');
      if (hoveredControl) handleHoverTarget(hoveredControl, 0);
    }

    function revealWhenStable() {
      if (root.dataset.dnmReady === 'true' || root._dnmRevealStarted) return;

      root._dnmRevealStarted = true;

      var revealed = false;

      function reveal() {
        if (revealed || !root.isConnected) return;
        revealed = true;

        var commit = function () {
          if (!root.isConnected) return;
          root.dataset.dnmReady = 'true';
          root._dnmRevealStarted = false;
          warmOpenIfHovered();
        };

        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(commit);
        } else {
          window.setTimeout(commit, 0);
        }
      }

      /* Webfont genişlikleri hazır olduktan sonra göster.
         700 ms emniyet fallback'i, olası font/network probleminde menünün
         görünmez kalmasını engeller. */
      var fallbackTimer = window.setTimeout(reveal, 700);

      if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(function () {
          window.clearTimeout(fallbackTimer);
          reveal();
        }, function () {
          window.clearTimeout(fallbackTimer);
          reveal();
        });
      } else {
        window.clearTimeout(fallbackTimer);
        reveal();
      }
    }

    primeInitialState(root);
    setPanelTop(root);
    revealWhenStable();

    function handlePrimaryOver(event) {
      if (!isDesktop() || !supportsHover()) return;
      handleHoverTarget(event.target);
    }

    function handlePrimaryLeave() {
      if (!isDesktop() || !supportsHover()) return;
      scheduleClose();
    }

    if (hasPointerEvents) {
      addManagedListener(root, 'pointerover', handlePrimaryOver);
      addManagedListener(root, 'pointerleave', handlePrimaryLeave);
    } else {
      addManagedListener(root, 'mouseover', handlePrimaryOver);
      addManagedListener(root, 'mouseleave', handlePrimaryLeave);
    }

    function onRootFocusIn(event) {
      if (!isDesktop()) return;

      var handledType = handleHoverTarget(event.target, 0);
      if (handledType && handledType !== 'plain') {
        setOpen(root, true);
      }
    }

    addManagedListener(root, 'focusin', onRootFocusIn);

    function onRootClick(event) {
      if (!isDesktop()) return;

      var plainTop = closestElement(event.target, '[data-dnm-top-plain]');
      var l1 = closestElement(event.target, '[data-dnm-l1]');
      var l2 = closestElement(event.target, '[data-dnm-l2]');
      var l2Empty = closestElement(event.target, '[data-dnm-l2-empty]');

      if (plainTop && root.contains(plainTop)) {
        closeForPlainTopLink();
        return;
      }

      if (l1 && root.contains(l1)) {
        event.preventDefault();
        activateL1(root, l1.getAttribute('data-dnm-l1'));
        setOpen(root, true);
        return;
      }

      if (l2 && root.contains(l2)) {
        activateL2(root, l2.getAttribute('data-dnm-l2'));
        setOpen(root, true);

        if (l2.tagName && l2.tagName.toLowerCase() === 'a') {
          return;
        }

        event.preventDefault();
        return;
      }

      if (l2Empty && root.contains(l2Empty)) {
        activateEmptyL2(root, l2Empty.getAttribute('data-dnm-l2-empty'));
      }
    }

    addManagedListener(root, 'click', onRootClick);

    function onDocumentMove(event) {
      if (!isDesktop() || !supportsHover()) return;

      if (root.classList.contains('is-open')) {
        scheduleCloseIfOutsideBounds(event);
        return;
      }

      if (!root.contains(event.target)) return;
      handleHoverTarget(event.target, 0);
    }

    if (hasPointerEvents) {
      addManagedListener(document, 'pointermove', onDocumentMove);
    } else {
      addManagedListener(document, 'mousemove', onDocumentMove);
    }

    function onDocumentClick(event) {
      if (!root.contains(event.target)) {
        window.clearTimeout(hoverTimer);
        setOpen(root, false);
      }
    }

    addManagedListener(document, 'click', onDocumentClick);

    function onDocumentFocusIn(event) {
      if (!root.contains(event.target)) {
        window.clearTimeout(hoverTimer);
        setOpen(root, false);
      }
    }

    addManagedListener(document, 'focusin', onDocumentFocusIn);

    function onDocumentKeydown(event) {
      if (event.key === 'Escape') {
        window.clearTimeout(hoverTimer);
        setOpen(root, false);
      }
    }

    addManagedListener(document, 'keydown', onDocumentKeydown);

    function onWindowResize() {
      if (!isDesktop()) {
        setOpen(root, false);
        return;
      }
      primeInitialState(root);
      if (root.classList.contains('is-open')) setPanelTop(root);
    }

    addManagedListener(window, 'resize', onWindowResize);

    function onWindowScroll() {
      if (root.classList.contains('is-open')) setPanelTop(root);
    }

    addManagedListener(window, 'scroll', onWindowScroll);

    window.setTimeout(function () {
      if (root.dataset.dnmReady === 'true') warmOpenIfHovered();
    }, 60);

    window.setTimeout(function () {
      if (root.dataset.dnmReady === 'true') warmOpenIfHovered();
    }, 240);
  }

  function init() {
    document.querySelectorAll('[data-dnm-root]').forEach(initRoot);
  }

  function scheduleInit() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(init);
    } else {
      window.setTimeout(init, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

  window.setTimeout(init, 120);
  window.setTimeout(init, 500);
  window.setTimeout(init, 1200);

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;

    var roots = event.target.querySelectorAll ? event.target.querySelectorAll('[data-dnm-root]') : [];
    Array.prototype.forEach.call(roots, function (root) {
      if (root && typeof root._dnmCleanup === 'function') {
        root._dnmCleanup();
      }
    });
  });

  window.addEventListener('pageshow', init);
})();
